import Auth from './auth.service'
import Company from './company.service'
import Score from './score.service'
import Payment from './payment.service'
import User from './user.service'
import Code from './code.service'
import Leaks from './leaks.service'
import Invite from './invite.service'
import ResponsePlan from './response.plan.service'
import EmailVerification from './emailVerification.service'
import Notifications from './notification.service'
import Scan from './scan.service'
import InviteAdmin from './invite-admin.service'
import CyberMatch from './cybermatch.service'

export default {
  Score,
  Auth,
  Company,
  Payment,
  User,
  Code,
  Leaks,
  ResponsePlan,
  Invite,
  EmailVerification,
  Notifications,
  Scan,
  InviteAdmin,
  CyberMatch,
}
